// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
:host .bottom_fixed ::ng-deep app-buttons-footer .footer-content {
  --app-space-content-bottom: calc(
      var(--ion-safe-area-bottom, 0) + 20px
  );
}
:host .bottom_fixed {
  flex: 0 1;
}
:host .bottom_fixed ion-thumbnail {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-footer/skeleton-footer.component.scss"],"names":[],"mappings":"AAAA;EACI,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AACJ;AACQ;EACI;;GAAA;AAGZ;AALI;EAMI,SAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;AAGZ","sourcesContent":[":host {\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    .bottom_fixed {\r\n        ::ng-deep app-buttons-footer .footer-content {\r\n            --app-space-content-bottom: calc(\r\n                var(--ion-safe-area-bottom, 0) + 20px\r\n            );\r\n        }\r\n        flex: 0 1;\r\n        ion-thumbnail {\r\n            width: 100%;\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
